export default "__VITE_ASSET__BGyvIIWb__"